import React, { useMemo } from "react"
import { useEsriModules } from "../common/useEsriModules"
import { WebMapView } from "../common/WebMapView"

export const Map: React.FC = () => {
  /** Get esri modules and generate layers */
  const [FeatureLayer, WebTileLayer] = useEsriModules([
    "esri/layers/FeatureLayer",
    "esri/layers/WebTileLayer",
  ])

  /** Load layers into memo */
  const layers = useMemo(() => {
    const baseLayers = FeatureLayer &&
      WebTileLayer && [
        new WebTileLayer({
          urlTemplate:
            "https://api.mapbox.com/styles/v1/gisfeedback/ckd3sscr10dou1jkc1fydngj8/tiles/256/{level}/{col}/{row}@2x?access_token=pk.eyJ1IjoiZ2lzZmVlZGJhY2siLCJhIjoiY2l2eDJndmtjMDFkeTJvcHM4YTNheXZtNyJ9.-HNJNch_WwLIAifPgzW2Ig",
        }),
        new FeatureLayer({
          url:
            "https://services1.arcgis.com/KGdHCCUjGBpOPPac/arcgis/rest/services/Municipal_Boundaries/FeatureServer",
        }),
        new FeatureLayer({
          url:
            "https://services1.arcgis.com/KGdHCCUjGBpOPPac/arcgis/rest/services/Municipal_Boundaries/FeatureServer/1",
        }),
      ]

    return baseLayers
  }, [FeatureLayer, WebTileLayer])

  return <WebMapView layers={layers} zoom={15} center={[144.9631, -37.8136]} />
}
